import { ImageWithPlaceholder } from '@/common/components/ImageWithPlaceholder'
import ResumeItem from '@/common/components/ResumeItem'
import { cn } from '@/common/utils/cn'
import { formatCnpj, formatPhoneNumber } from '@/common/utils/formatters'
import { MaintenanceWorkflowAllowedEstablishmentData } from '@/features/maintenanceWorkflow/pages/Show/types/maintenanceWorkflowAllowedEstablishment.type'
import { Building2Icon } from 'lucide-react'

interface EstablishmentChoiceListItemProps {
  establishment: MaintenanceWorkflowAllowedEstablishmentData
  isChecked: boolean
  onSelectEstablishment: (establishment: MaintenanceWorkflowAllowedEstablishmentData) => void
}

const EstablishmentChoiceListItem = ({
  establishment,
  isChecked,
  onSelectEstablishment,
}: EstablishmentChoiceListItemProps) => {
  return (
    <div
      className={cn(
        'flex flex-col gap-3 bg-white-100 hover:bg-white-200 transition-colors cursor-pointer p-4 rounded-md',
        isChecked && 'bg-blue-300 hover:bg-blue-300/40',
      )}
      onClick={() => onSelectEstablishment(establishment)}
    >
      <div className="flex items-center gap-2">
        <ImageWithPlaceholder placeholderIcon={Building2Icon} className="size-5" iconClassName="size-3" />

        <p className="text-sm font-bold">{establishment.general_information?.fantasy_name}</p>
      </div>

      <div className="flex flex-col gap-1">
        <p className="italic font-light text-sm">{establishment?.general_information?.address?.full || '--'}</p>
      </div>

      <div className="flex gap-3">
        <ResumeItem
          label="Telefone"
          value={
            establishment.general_information?.phone?.number
              ? formatPhoneNumber(establishment.general_information?.phone?.number)
              : '--'
          }
          className="text-xs"
        />

        <ResumeItem
          label="Razão social"
          value={establishment.general_information?.official_name || '--'}
          className="text-xs"
        />

        <ResumeItem
          label="CNPJ"
          value={establishment.general_information?.cnpj ? formatCnpj(establishment.general_information?.cnpj) : '--'}
          className="text-xs"
        />
      </div>
    </div>
  )
}

export default EstablishmentChoiceListItem
